import { createSelector } from 'reselect';
import objectToArray from '../../../../common/utils/object-to-array';

const legislatorsStateSelector = ({ entities: { legislators } = {} }) =>
  legislators;

export const getLegislators = createSelector(
  [legislatorsStateSelector],
  legislators => {
    return objectToArray(legislators || {});
  }
);



// WEBPACK FOOTER //
// ./src/App/account/selectors/legislators/index.js